import { isEmpty } from 'lodash';
import travelConnectReducer from 'travel-connect/store/reducers';
import databaseReducer from './database.reducer';
import metaDatabase from './metaDatabase.reducer';
import authReducer from './auth.reducer';

const initialState = {
    auth: {},
    database: {},
    metaDatabase: {},
    travelConnect: {},
};

export default function (st, action)
{
    const state = isEmpty(st) ? initialState : st;

    return {
        auth: authReducer(state.auth, action),
        database: databaseReducer(state.database, action),
        metaDatabase: metaDatabase(state.metaDatabase, action),
        travelConnect: travelConnectReducer(state.travelConnect, action),
    };
}
